import { FC } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/refresh-data.png';
import myIdLogo from '../../assets/logos/myidlogo.svg';
import styles from './Login.module.scss';

const Login: FC = () => {
  const sessionRevoked = sessionStorage.getItem('sessionRevoked');
  const navigate = useNavigate();

  const handleButtonClick = (): void => {
    sessionStorage.removeItem('sessionRevoked');
    navigate('/');
  };

  return (
    <div className={styles.login}>
      <h1>{sessionRevoked ? 'Session Expired' : 'Welcome to OMS'}</h1>
      {sessionRevoked ? (
        <img src={logo} width={100} alt="Metastore Logo" />
      ) : (
        <img src={myIdLogo} width={100} alt="MyId Logo" />
      )}
      <p>{`${sessionRevoked ? 'Your session has been expired. ' : ''}Please login again.`}</p>
      <Button onClick={handleButtonClick} variant="contained" color="primary">
        Login
      </Button>
    </div>
  );
};

export default Login;
